<template>
  <div>
    <!-- Main selector -->
    <div class="section-header-wrapper">
      <a href="#" class="icon-sorting">
        <img
          v-if="!sortOrder"
          src="../../assets/img/icon-sort-ascending.png"
          alt="Sort"
          @click.prevent="toggleSortOrder"
        />

        <img
          v-else
          src="../../assets/img/icon-sort-descending.png"
          alt="Sort"
          @click.prevent="toggleSortOrder"
        />
      </a>
      <!-- Client -->
      <label class="container-radio" @click.prevent="changeSelected('all')">
        <span class="checkmark" :class="{ checked: selected === 'all' }"></span
        >All
      </label>

      <!-- Person -->
      <label class="container-radio" @click.prevent="changeSelected('client')">
        <span
          class="checkmark"
          :class="{ checked: selected === 'client' }"
        ></span
        >Client
      </label>

      <!-- Event -->
      <label class="container-radio" @click.prevent="changeSelected('other')">
        <span
          class="checkmark"
          :class="{ checked: selected === 'other' }"
        ></span
        >Other
      </label>
    </div>

    <!-- When client is selected -->
    <client-bottom
      v-if="selected === 'client'"
      :selected-client="selectedClient"
      :change-selected-client="changeSelectedClient"
    />

    <!-- When others is selected -->
    <others-bottom
      v-if="selected === 'other'"
      :selected-other="selectedOther"
      :changeSelectedOther="changeSelectedOther"
    />
  </div>
</template>

<script>
import ClientBottom from "./ClientBottom";
import OthersBottom from "./OthersBottom";

export default {
  name: "SectionHeader",
  props: {
    selected: String,
    selectedClient: String,
    selectedOther: String,
    sortOrder: Boolean,
    changeSelected: Function,
    changeSelectedClient: Function,
    changeSelectedOther: Function,
    toggleSortOrder: Function
  },
  components: {
    ClientBottom,
    OthersBottom
  }
};
</script>

<style scoped>
.section-header-wrapper {
  margin-top: 70px;
  margin-left: 1em;
  line-height: 1.4em;
  margin-bottom: 5px;
  position: relative;
}
.icon-sorting {
  position: absolute;
  top: 0;
  right: 15px;
}
.icon-sorting img {
  display: block;
}
</style>
